import { ReactElement } from "react";
import { FormattedText, Typography } from "client/Components";
import { CommunityPostNotificationDataViewModel } from "client/Api/Notifications/notifications";
import { localize } from "client_legacy/ndaw/culture";
import {
	isNotNil,
	isNotNilOrEmpty,
	setTrackingId
} from "client/Misc/utils";
import { getComputedDisplayName } from "client/Features/AddressBook/common";
import { CommunityKind } from "client/Api/Communities/community";

export type CommunityPostActivityProps = {
	data: CommunityPostNotificationDataViewModel;
};

export const CommunityPostActivity = (props: CommunityPostActivityProps): ReactElement => {
	const { data } = props;

	const {
		messagePreview,
		user,
		communityName,
		communityKind
	} = data;

	const displayName: string = isNotNil(user)
		? getComputedDisplayName({
			firstName: user.firstName,
			lastName: user.lastName
		}).computedDisplayName
		: localize("_DeletedUser");

	const preparedPostTitleAndComment: string = preparePostTitleAndComment(messagePreview ?? "");

	const displayCommunityName: string | null = communityKind === CommunityKind.AllCompany
		? localize("_AllCompany")
		: communityName;


	return (
		<span {...setTrackingId("title")}>
			<FormattedText
				text={
					localize(
						isNotNilOrEmpty(preparedPostTitleAndComment)
							? "_UserXCreatedNewPostInCommunityYWithTitleZ"
							: "_UserXCreatedNewPostInCommunityY"
					)
				}
				thingsToReplace={[
					{
						what: "{{Username}}",
						filler: (
							<Typography
								trackingId="name"
								weight="bold"
							>
								{displayName}
							</Typography>
						)
					},
					{
						what: "{{Post}}",
						filler: (
							<span {...setTrackingId("message")}>
								{preparedPostTitleAndComment}
							</span>
						)
					},
					{
						what: "{{Community}}",
						filler: (
							<Typography
								trackingId="community-name"
								weight="bold"
							>
								{displayCommunityName}
							</Typography>
						)
					}
				]}
			/>
		</span>
	);
};

CommunityPostActivity.displayName = "CommunityPostActivity";

const MAX_POST_TITLE_LENGTH = 50;

export function preparePostTitleAndComment(title: string): string {
	title = title.trim();

	if (title.length <= MAX_POST_TITLE_LENGTH) {
		return title;
	}

	return title.slice(0, MAX_POST_TITLE_LENGTH - 1) + "…";
}